import React from 'react';
import {Box, Typography} from '@mui/material';
import BoltIcon from '@mui/icons-material/Bolt';
import BarChartIcon from '@mui/icons-material/BarChart';
import ShieldIcon from '@mui/icons-material/Shield';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

const LOGIN_COLORS = {
    bg: '#f1f5f9',
    brand: '#2563eb',
    slate900: '#0f172a',
    slate500: '#64748b',
    slate400: '#94a3b8',
    slate100: '#f1f5f9',
    slate200: '#e2e8f0',
};

const features = [
    {icon: AutoAwesomeIcon, label: 'Discovery'},
    {icon: BarChartIcon, label: 'Analysis'},
    {icon: ShieldIcon, label: 'Summaries & Highlights'},
];

const LoginShell = ({children, alert}) => {
    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: LOGIN_COLORS.bg,
                px: 2,
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    maxWidth: 768,
                    minWidth: {md: 768},
                    overflow: 'hidden',
                    borderRadius: 4,
                    bgcolor: 'white',
                    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
                }}
            >
                <Box sx={{display: 'flex'}}>
                    {/* Left panel - hidden on mobile */}
                    <Box
                        sx={{
                            display: {xs: 'none', md: 'flex'},
                            width: {md: '32%'},
                            flexDirection: 'column',
                            bgcolor: 'white',
                            borderRight: '1px solid',
                            borderColor: LOGIN_COLORS.slate100,
                        }}
                    >
                        <Box>
                            {/* Logo */}
                            <Box sx={{px: 3, pt: 5}}>
                                <Box sx={{display: 'flex', alignItems: 'center', gap: 1.25, mb: 3}}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            height: 28,
                                            width: 28,
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            borderRadius: 1,
                                            bgcolor: LOGIN_COLORS.brand,
                                        }}
                                    >
                                        <BoltIcon sx={{height: 14, width: 14, color: 'white'}}/>
                                    </Box>
                                    <Box>
                                        <Typography
                                            sx={{
                                                fontSize: 13,
                                                fontWeight: 700,
                                                lineHeight: 1.2,
                                                color: LOGIN_COLORS.slate900,
                                            }}
                                        >
                                            DASH
                                        </Typography>
                                        <Typography
                                            sx={{
                                                fontSize: 9,
                                                lineHeight: 1.2,
                                                color: LOGIN_COLORS.slate400,
                                            }}
                                        >
                                            by dMetrics
                                        </Typography>
                                    </Box>
                                </Box>
                            </Box>

                            {/* Wave banner */}
                            <Box sx={{mb: 4, overflow: 'hidden', bgcolor: 'white'}}>
                                <img
                                    src="/login-wave-banner.png"
                                    alt=""
                                    width={1024}
                                    height={336}
                                    draggable={false}
                                    style={{
                                        display: 'block',
                                        height: 60,
                                        width: '100%',
                                        objectFit: 'cover',
                                        objectPosition: '50% 48%',
                                        userSelect: 'none',
                                    }}
                                    aria-hidden="true"
                                />
                            </Box>

                            {/* Feature bullets */}
                            <Box component="ul" sx={{listStyle: 'none', p: 0, px: 3, m: 0}}>
                                {features.map(({icon: Icon, label}) => (
                                    <Box
                                        component="li"
                                        key={label}
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1.5,
                                            mb: 2,
                                        }}
                                    >
                                        <Icon
                                            sx={{
                                                height: 14,
                                                width: 14,
                                                color: LOGIN_COLORS.brand,
                                                flexShrink: 0,
                                            }}
                                        />
                                        <Typography
                                            sx={{
                                                fontSize: 13,
                                                color: LOGIN_COLORS.slate500,
                                            }}
                                        >
                                            {label}
                                        </Typography>
                                    </Box>
                                ))}
                            </Box>
                        </Box>
                    </Box>

                    {/* Right panel */}
                    <Box
                        sx={{
                            display: 'flex',
                            width: {xs: '100%', md: '68%'},
                            flexDirection: 'column',
                            justifyContent: 'center',
                            px: 5,
                            py: 6,
                        }}
                    >
                        {alert && <Box sx={{mb: 2.5}}>{alert}</Box>}
                        {children}
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default LoginShell;
export {LOGIN_COLORS};
